import type { DatedPhase, JiraData } from './types';

const sumIn = (periods: Record<string, number>, from: string | null, to: string | null) =>
  Object.entries(periods)
    .filter(([p]) => (!from || p >= from) && (!to || p <= to))
    .reduce((sum, [, h]) => sum + h, 0);

/* Heures Jira d'un projet sur les dates d'une phase. Au jour près quand la synchro fournit les
   totaux par jour (arbitrage du 2026-10-02 : une phase finie le 16/07 et la suivante commencée le
   17/07 ne comptent plus juillet toutes les deux) ; sinon par mois entiers. */
export function phaseJiraHours(
  jiraData: JiraData,
  jiraProjectKey: string | null | undefined,
  phase: DatedPhase,
): number {
  if (!jiraProjectKey) return 0;
  const days = (jiraData.byProjectDay || {})[jiraProjectKey];
  if (days && Object.keys(days).length)
    return sumIn(days, phase.dateDebut || null, phase.dateFin || null);
  const months = (jiraData.byProjectMonth || {})[jiraProjectKey] || {};
  return sumIn(months, phase.dateDebut?.slice(0, 7) || null, phase.dateFin?.slice(0, 7) || null);
}
